import { Flex } from '@chakra-ui/react';

interface Props {
  children: React.ReactNode;
  fulfilled: boolean;
  icon: React.ReactNode;
  onClick?: () => void;
}

export function Slot({ children, fulfilled, icon, onClick }: Props) {
  return (
    <Flex
      alignItems="center"
      gap={2}
      p={4}
      borderRadius="md"
      background="blackAlpha.100"
      {...(!fulfilled && {
        opacity: 0.5,
        border: '1px dashed',
        borderColor: 'gray.300',
        background: 'transparent',
      })}
      {...(onClick && {
        cursor: 'pointer',
        _hover: { background: fulfilled ? 'blackAlpha.200' : 'gray.50' },
      })}
      onClick={onClick}
    >
      {icon}
      {children}
    </Flex>
  );
}
